export default {
    details: 'No account with your email was found on {supplier}',
    goHome: 'Go to home',
    title: '{supplier} Account not found',
    deskit: 'Deskit',
};
